export const localesToAddZeroFirstToMonth = ['ja', 'ko', 'zh', 'vi'];
//# sourceMappingURL=locales.js.map